import { createApi } from "@reduxjs/toolkit/query/react";
import { ENDPOINTS, METHODS } from "src/constants/API";
import {
  ICertificateCreateBurnTokenPayload,
  ICertificateCreateProjectPayload,
  ICertificateCreateProjectResponse,
  ICertificateCreateUserCompanyPayload,
  ICertificateCreateUserCompanyResponse,
  ICertificateGetCertificatePayload,
  ICertificateGetCertificateResponse,
} from "src/types/certificate.types";
import { baseQuery } from "src/utils/baseQuery";

export const CertificateApi = createApi({
  reducerPath: "certificate-api",
  baseQuery: baseQuery(true),
  endpoints: (builder) => ({
    createUserCompany: builder.mutation<
      ICertificateCreateUserCompanyResponse,
      ICertificateCreateUserCompanyPayload
    >({
      query: (body) => ({
        url: ENDPOINTS.certificate.createUserCompany,
        method: METHODS.post,
        body,
      }),
    }),
    createProject: builder.mutation<
      ICertificateCreateProjectResponse,
      ICertificateCreateProjectPayload
    >({
      query: (body) => ({
        url: ENDPOINTS.certificate.createProject,
        method: METHODS.post,
        body,
      }),
    }),
    createBurnToken: builder.mutation<
      unknown,
      ICertificateCreateBurnTokenPayload
    >({
      query: (body) => ({
        url: ENDPOINTS.certificate.utilize,
        method: METHODS.post,
        body,
      }),
    }),
    getCertificate: builder.mutation<
      ICertificateGetCertificateResponse,
      ICertificateGetCertificatePayload
    >({
      query: (body) => ({
        url: ENDPOINTS.certificate.get,
        method: METHODS.post,
        body,
      }),
    }),
  }),
});

export const {
  useCreateUserCompanyMutation,
  useCreateProjectMutation,
  useCreateBurnTokenMutation,
  useGetCertificateMutation,
} = CertificateApi;
